import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ComputedRef, PropType, computed } from 'vue';
import { VueAttributeClass } from '@/types/attributes-vue';
import { useDropdownIcon } from '@/composables/use-dropdown-icon';
import AppIcon from '@/components/Base/AppIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppDropdownIcon',
  props: {
  active: {
    type: Boolean,
    required: true,
  },
  class: {
    type: [String, Object] as PropType<VueAttributeClass>,
    default: 'h-[24px] drop-shadow-md',
  },
},
  setup(__props) {

const props = __props;



const icon: ComputedRef<string> = computed((): string => {
  return useDropdownIcon(props.active);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppIcon, {
    class: _normalizeClass(props.class),
    src: _unref(icon)
  }, null, 8, ["class", "src"]))
}
}

})